// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Thicker input/select borders */
.thick-border {
  border-width: 2px !important;
  border-color: #ced4da !important;
  border-radius: 0.6rem;
}

/* Better focus style */
.thick-border:focus {
  border-color: #198754 !important; /* bootstrap success */
  box-shadow: 0 0 0 0.2rem rgba(25, 135, 84, 0.2) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,gCAAgC,EAAE,sBAAsB;EACxD,0DAA0D;AAC5D","sourcesContent":["/* Thicker input/select borders */\n.thick-border {\n  border-width: 2px !important;\n  border-color: #ced4da !important;\n  border-radius: 0.6rem;\n}\n\n/* Better focus style */\n.thick-border:focus {\n  border-color: #198754 !important; /* bootstrap success */\n  box-shadow: 0 0 0 0.2rem rgba(25, 135, 84, 0.2) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
